import { requestPost } from '@/common/request';

export interface inventoryOperateParams {
  activityId: string;
  inventoryIds: Array<string> | [];
  opt: number;
}

export interface inventoryOperateRes {
  ret: string;
  msg: string;
  data: {};
}

//品类盘货 - 接收、驳回或移除盘货，规则变更确认
export async function inventoryOperate(params: inventoryOperateParams): Promise<inventoryOperateRes> {
  return await requestPost('/goodsPool/inventoryOperate', params);
}
